import axios, { AxiosResponse } from "axios";
import { CategoryDto } from "../../dto/category.dto";
import { CustomChallengeListViewDto } from "../../dto/custom-challenge-list-view.dto.ts";
import { CompetitiveChallengeDetailsDto } from "../../dto/competitive-challenge-details.dto.ts";
import { CustomChallengeDetailsDto } from "../../dto/custom-challenge-details.dto.ts";
import { ChartDataDto } from "../../dto/chart-data.dto.ts";

export function fetchAllCustomChallenges(
  clientCode: string
): Promise<AxiosResponse<CustomChallengeListViewDto[]>> {
  return axios.post("custom-challenges/all", {
    code: clientCode,
  });
}

export function fetchActiveCustomChallenges(
  externalUserId: string
): Promise<AxiosResponse<CustomChallengeListViewDto[]>> {
  return axios.post("custom-challenges", {
    externalUserId: externalUserId,
  });
}

export function fetchCustomChallenge(
  externalUserId: string,
  code: string,
  id: string
): Promise<AxiosResponse<CustomChallengeDetailsDto>> {
  return axios.post("custom-challenge", {
    externalUserId: externalUserId,
    code: code,
    id: id,
  });
}

export function startCustomChallenge(
  externalUserId: string,
  id: string
): Promise<AxiosResponse<CustomChallengeDetailsDto>> {
  return axios.post("custom-challenge/start", {
    externalUserId: externalUserId,
    id: id,
  });
}

export function fetchChartData(
  externalUserId: string,
  interval: string,
  id: string
): Promise<AxiosResponse<ChartDataDto[]>> {
  return axios.post("custom-challenge/statistics/chart-data", {
    externalUserId: externalUserId,
    interval: interval,
    id: id,
  });
}

export function fetchChartDataList(
  externalUserId: string,
  id: string
): Promise<AxiosResponse<ChartDataDto[]>> {
  return axios.post("custom-challenge/statistics", {
    externalUserId: externalUserId,
    id: id,
  });
}

export function updateProgress(
  id: string,
  externalUserId: string,
  value: number,
  date: string
): Promise<AxiosResponse<ChartDataDto[]>> {
  return axios.post("custom-challenge/progress", {
    externalUserId: externalUserId,
    id: id,
    value: value,
    date: date,
  });
}

export function fetchHistory(externalUserId: string): Promise<AxiosResponse> {
  return axios.post("challenge-history", {
    externalUserId: externalUserId,
  });
}
